module.exports = __webpack_public_path__ + "img/buyCompany.c4df7755.png";